export var SlotsMixin = {
  methods: {
    slots(name, props) {
      if (name === void 0) {
        name = 'default';
      }
      var {
        $slots,
        $scopedSlots
      } = this;
      var scopedSlot = $scopedSlots[name];
      return scopedSlot ? scopedSlot(props) : $slots[name];
    },
    hasSlots(name) {
      if (name === void 0) {
        name = 'default';
      }
      return this.$scopedSlots[name] || this.$slots[name];
    }
  }
};